<template>
    <div>
      <ul class="c-footer-nav-list">
          <li class="c-active"><a><i class="fa fa-calendar" aria-hidden="true"></i></a></li>
          <li><a><i class="fa fa-archive" aria-hidden="true"></i></a></li>
          <li><a><i class="fa fa-credit-card" aria-hidden="true"></i></a></li>
      </ul>
    </div>
</template>

<script>
import EventBus from '@/EventBus'
import router from '@/router/index'
export default {
  name: 'FooterNavList',
  router: router,
  data () {
    return {
      msg: 'Welcome to Your Vue.js PWA'
    }
  },
  methods: {
  },
  created () {
    /* #region Router Changers functions */
    // this.$router.onReady(function () {
    //   if (this.$route.name) {
    //     this.currentViewName = this.$route.name
    //   }
    // }.bind(this))
    // this.$router.beforeEach(function (to, from, next) {
    //   this.currentViewName = to.name
    //   next()
    // }.bind(this))
    /* #endregion Router Changers functions */
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/footer/FooterNavList.vue